import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templateAccountLoginSecurity = document.createElement('template');

templateAccountLoginSecurity.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='login-security-section'>
    <gz-title fontSize='18' fontWeight='${FontWeights.MEDIUM}' class='subsection-title' id='login-security-section-title'></gz-title>

    <gz-form-field id='authentication-method' label=''>
      <gz-dropdown gz-form-input type='dropdown' id='authentication-method-dropdown' class='input-content' inputWidth='320px'></gz-dropdown>
      <gz-input-error></gz-input-error>
    </gz-form-field>

    <div id='two-fa-section'>
      <gz-text fontSize='${FontSizes.HEADING_6}' id='check-status-description'></gz-text>

      <div id='two-fa-enable-steps'>
        <gz-text fontSize='${FontSizes.HEADING_6}' id='two-fa-info'></gz-text>
        <gz-enumeration-icon value='1'><gz-text fontSize='${FontSizes.HEADING_6}' id='two-fa-enable-step-1'></gz-text></gz-enumeration-icon>
        <gz-enumeration-icon value='2'><gz-text fontSize='${FontSizes.HEADING_6}' id='two-fa-enable-step-2'></gz-text></gz-enumeration-icon>
        <gz-enumeration-icon value='3'><gz-text fontSize='${FontSizes.HEADING_6}' id='two-fa-enable-step-3'></gz-text></gz-enumeration-icon>
        <gz-enumeration-icon value='4'><gz-text fontSize='${FontSizes.HEADING_6}' id='two-fa-enable-step-4'></gz-text></gz-enumeration-icon>
      </div>

      <gz-text fontSize='${FontSizes.HEADING_6}' id='reset-2fa-description'></gz-text>

      <gz-form-field id='user-password' label='' required>
        <gz-input gz-form-input type='password' class='input-content' placeholder='' inputwidth='240'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>
      <gz-text fontSize='${FontSizes.HEADING_6}' id='revoke-reset-description'></gz-text>

      <gz-button id='revoke-button' type='full' buttonHeight='small' lowercase='true'></gz-button>
      <gz-button id='reset-button' type='full' buttonHeight='small' lowercase='true'></gz-button>
      <gz-text fontSize='${FontSizes.HEADING_6}' id='after-reset-description'></gz-text>
    </div>

    <gz-form-field id='password-expiration'>
      <gz-checkbox gz-form-input id='password-expiration-checkbox' label=''></gz-checkbox>
      <gz-text class="helper-text" fontSize='${FontSizes.PARAGRAPH_12}' id='password-expiration-description'></gz-text>
    </gz-form-field>

    <gz-form-field id='account-lockout'>
      <gz-checkbox gz-form-input id='account-lockout-checkbox' label=''></gz-checkbox>
      <gz-text class="helper-text" fontSize='${FontSizes.PARAGRAPH_12}' id='account-lockout-description'></gz-text>
    </gz-form-field>

    <gz-form-field id='concurrent-sessions'>
      <gz-checkbox gz-form-input id='concurrent-sessions-checkbox' label=''></gz-checkbox>
      <gz-text class="helper-text" fontSize='${FontSizes.PARAGRAPH_12}' id='concurrent-sessions-description'></gz-text>
    </gz-form-field>
  </div>`;
